<template>
  <div class="water-usage-analysis">
    <div class="usage-tabs">
      <button 
        v-for="tab in tabs" 
        :key="tab.key"
        :class="['tab-button', { active: activeTab === tab.key }]"
        @click="activeTab = tab.key"
      >
        {{ tab.label }}
      </button>
    </div>
    
    <div class="usage-content">
      <div class="usage-stats">
        <div class="stat-card">
          <div class="stat-icon">
            <svg-icon name="water" class-name="stat-icon-svg" />
          </div>
          <div class="stat-info">
            <span class="stat-value">{{ currentUsage }}</span>
            <span class="stat-unit">{{ currentUnit }}</span>
            <span class="stat-label">{{ currentLabel }}</span>
          </div>
        </div>
      </div>
      
      <div class="usage-chart">
        <Echart ref="usageChart" :options="chartOptions" style="height: 100%; width: 100%" />
      </div>
    </div>
  </div>
</template>

<script>
import { putAction } from '@/api/manage'
import * as echarts from 'echarts'
export default {
  name: 'WaterUsageAnalysis',
  data() {
    return {
      activeTab: 'total',
      tabs: [
        { key: 'total', label: this.$t('本年总量') },
        { key: 'month', label: this.$t('本月总量') },
        { key: 'lastMonth', label: this.$t('上月总量') },
        { key: 'week', label: this.$t('近7日总量') }

      ],
      loading: false,
      usageData: {
        userCountNoFlow: 0,
        waterUseYear: 0,
        waterUseLatest7Days: 0,
        waterUseCurMonth: 0,
        waterUseLastMonth: 0
      },
      url: {
        list: '/jeecg-charge/meter/waterAnalysis/waterUse'
      }
    }
  },
  computed: {
    currentUsage() {
      if (this.activeTab === 'total') {
        return this.formatValue(this.usageData.waterUseYear)
      } else if (this.activeTab === 'month') {
        return this.formatValue(this.usageData.waterUseCurMonth)
      } else if (this.activeTab === 'lastMonth') {
        return this.formatValue(this.usageData.waterUseLastMonth)
      } else if (this.activeTab === 'week') {
        return this.formatValue(this.usageData.waterUseLatest7Days)
      }
    },
    currentUnit() {
      return this.formatUnit(this.usageData.waterUseYear)
    },
    currentLabel() {
      if (this.activeTab === 'total') {
        return this.$t('年度累计用水量')
      } else if (this.activeTab === 'month') {
        return this.$t('本月累计用水量')
      } else if (this.activeTab === 'lastMonth') {
        return this.$t('上月累计用水量')
      } else if (this.activeTab === 'week') {
        return this.$t('近7日累计用水量')
      }
    },
    chartOptions() {
      return {
        grid: {
          top: '10%',
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [this.$t('近7日'), this.$t('本月'), this.$t('上月'), this.$t('年度')],
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 9
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.3)'
            }
          },
          axisLabel: {
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: 9
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)'
            }
          }
        },
        series: [{
          type: 'bar',
          data: [
            this.usageData.waterUseLatest7Days,
            this.usageData.waterUseCurMonth,
            this.usageData.waterUseLastMonth,
            this.usageData.waterUseYear
          ],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00D2FF' },
              { offset: 1, color: '#3A7BD5' }
            ]),
            borderRadius: [20, 20, 0, 0]
          },
          barWidth: '40%'
        }]
      }
    }
  },
  watch: {
    activeTab() {
      this.$nextTick(() => {
        if (this.$refs.usageChart) {
          this.$refs.usageChart.refresh()
        }
      })
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  },
  methods: {
    init() {
      this.queryWaterUseTotal()
    },
    queryWaterUseTotal() {
      this.loading = true
      putAction(this.url.list, {}).then((res) => {
        if(res.success){
          this.usageData = res.result
          this.usageData.waterUseYesterdayPercent = Number(res.result.waterUseYesterdayPercent || 0)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    formatValue(value) {
      if (value >= 10000) {
        return (value / 10000).toFixed(1)
      }
      return value.toLocaleString()
    },
    formatUnit(value) {
      if (value >= 10000) {
        return this.$t('万m³')
      }
      return 'm³'
    },
    skipPage(flag) {
      if(flag == 0) {
        this.$router.push({ path: "/meterAlarmManagement/trafficQueryList" })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.water-usage-analysis {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
  
  .usage-tabs {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
    
    .tab-button {
      flex: 1;
      padding: 0.375rem 0.5rem;
      background: rgba(0, 150, 255, 0.1);
      border: 1px solid rgba(0, 150, 255, 0.2);
      border-radius: 4px;
      color: rgba(255, 255, 255, 0.7);
      font-size: 0.75rem;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &.active {
        background: rgba(0, 150, 255, 0.3);
        border-color: rgba(0, 150, 255, 0.5);
        color: #fff;
      }
      
      &:hover:not(.active) {
        background: rgba(0, 150, 255, 0.2);
        border-color: rgba(0, 150, 255, 0.3);
      }
    }
  }
  
  .usage-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
  }
  
  .usage-stats {
    margin-bottom: 0.5rem;
  }
  
  .stat-card {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.75rem;
    background: rgba(0, 150, 255, 0.05);
    border: 1px solid rgba(0, 150, 255, 0.1);
    border-radius: 6px;
  }
  
  .stat-icon {
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 150, 255, 0.1);
    border-radius: 50%;
    border: 1px solid rgba(0, 150, 255, 0.2);
    flex-shrink: 0;
  }
  
  .stat-icon-svg {
    width: 1rem;
    height: 1rem;
    fill: #0096ff;
    filter: drop-shadow(0 0 6px rgba(0, 191, 255, 0.6));
  }
  
  .stat-info {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }
  
  .stat-value {
    font-family: 'ds-digital-bold', monospace;
    font-size: 1.5rem;
    font-weight: bold;
    color: #40a9ff;
    text-shadow: 0 0 10px rgba(0, 150, 255, 0.5);
  }
  
  .stat-unit {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.7);
  }
  
  .stat-label {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.7);
  }
  
  .usage-chart {
    flex: 1;
    min-height: 0;
    height: 100%;
  }
}

@media (max-width: 768px) {
  .water-usage-analysis {
    .usage-tabs {
      .tab-button {
        padding: 0.25rem 0.5rem;
        font-size: 0.625rem;
      }
    }
    
    .stat-card {
      padding: 0.5rem;
      gap: 0.5rem;
    }
    
    .stat-value {
      font-size: 1.25rem;
    }
  }
}
</style>